import { FaTv, FaBinoculars, FaIntercom } from "react-icons/fa";
import { HiOutlineWifi } from "react-icons/hi";
import { GiBarbecue } from "react-icons/gi";
import { BiRestaurant, BiShower, BiDrink } from "react-icons/bi";
import {
  MdOutlineLocalParking,
  MdOutlineLocalLaundryService,
  MdOutlineMeetingRoom,
  MdFamilyRestroom,
  MdOutlineKeyboardDoubleArrowDown,
  MdOutlineKeyboardDoubleArrowUp,
} from "react-icons/md";

import { HorizontalLine } from "../horizontal-line/horizontal-line";

import { useState } from "react";

export const Services = () => {
  const [showMore, setShowMore] = useState(false);

  const handleShowMore = () => {
    setShowMore(!showMore);
  };

  const services = [
    {
      icon: (
        <HiOutlineWifi className="mx-auto text-[42px] font-[100]"></HiOutlineWifi>
      ),
      title: "Free Wifi",
    },
    {
      icon: (
        <BiRestaurant className="mx-auto text-[42px] font-[100]"></BiRestaurant>
      ),
      title: "On-Site Restaurant",
    },
    {
      icon: <FaTv className="mx-auto text-[42px] font-[100]"></FaTv>,
      title: "Television",
    },
    {
      icon: <BiShower className="mx-auto text-[42px] font-[100]"></BiShower>,
      title: "Hot/Cold Shower",
    },
    {
      icon: (
        <MdOutlineLocalParking className="mx-auto text-[42px] font-[100]"></MdOutlineLocalParking>
      ),
      title: "Free Parking",
    },
    {
      icon: (
        <FaBinoculars className="mx-auto text-[42px] font-[100]"></FaBinoculars>
      ),
      title: "Lake View",
    },
    {
      icon: (
        <MdOutlineLocalLaundryService className="mx-auto text-[42px] font-[100]"></MdOutlineLocalLaundryService>
      ),
      title: "Laundary",
    },
    {
      icon: (
        <MdOutlineMeetingRoom className="mx-auto text-[42px] font-[100]"></MdOutlineMeetingRoom>
      ),
      title: "Conference Hall",
    },
    {
      icon: <BiDrink className="mx-auto text-[42px] font-[100]"></BiDrink>,
      title: "Bar",
    },
    {
      icon: (
        <GiBarbecue className="mx-auto text-[42px] font-[100]"></GiBarbecue>
      ),
      title: "BBQ",
    },
    {
      icon: (
        <FaIntercom className="mx-auto text-[42px] font-[100]"></FaIntercom>
      ),
      title: "Intercom",
    },
    {
      icon: (
        <MdFamilyRestroom className="mx-auto text-[42px] font-[100] "></MdFamilyRestroom>
      ),
      title: "Family Friendly",
    },
  ];

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const maxItem = windowWidth <= 990 ? 6 : services.length;

  window.addEventListener("resize", function () {
    setWindowWidth(window.innerWidth);
  });

  return (
    <div class="wrapper mb-[100px] ">
      <div className="">
        <h3 className="text-center text-[28px] mb-[25px] font-[400] mt-[50px] md:mt-[70px]">
          Services
        </h3>
        <HorizontalLine width={50} />

        <ul className="services-list w-[calc(100%_-_50px)] max-w-[1210px] mt-[45px] md:mt-[60px] flex flex-wrap mx-auto justify-center text-gray-text ">
          {services
            .slice(0, showMore ? services.length : maxItem)
            .map((item, index) => (
              <li
                key={index}
                className="flex-col justify-center items-center mt-[20px] mb-[40px] w-[50%] md:w-[16%]"
              >
                {services[index].icon}
                <div className="text-center pt-[8px] pb-[2px] font-[700] text-[14px]">
                  {services[index].title}
                </div>
              </li>
            ))}
        </ul>
        <button
          onClick={handleShowMore}
          className="flex text-golden bg-grayish-white w-[100%] justify-center md:hidden"
        >
          <div className="flex-col justify-center items-center">
            {showMore ? "See Less" : "See More"}
            {showMore ? (
              <MdOutlineKeyboardDoubleArrowUp className="text-[40px] ml-[15px]"></MdOutlineKeyboardDoubleArrowUp>
            ) : (
              <MdOutlineKeyboardDoubleArrowDown className="text-[40px] ml-[15px]"></MdOutlineKeyboardDoubleArrowDown>
            )}
          </div>
        </button>
      </div>
    </div>
  );
};
